import { PublicClientApplication } from '@azure/msal-browser';

const getRedirectUri = () => {
  if (process.env.REACT_APP_MSAL_REDIRECT_URI) {
    return process.env.REACT_APP_MSAL_REDIRECT_URI;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/`;
  }
  return 'http://localhost:3000/';
};

export const msalConfig = {
  auth: {
    clientId: '5cb11383-0162-4fa4-bc71-9fa5a35a5a85',
    authority: 'https://login.microsoftonline.com/c7886144-869f-423d-a018-9158602dc467',
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri(),
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ['User.Read'],
};
